<template>
  <div class="iframe-wrap" style="max-width:96rem;">
    <iframe :src="iframeSrc" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
export default {
  name: 'IframeWrap',
  props: {
    id: {}
  },
  data () {
    return {
      iframeSrc: ''
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.iframeSrc = `https://databoard.coocaa.in/kanban-config-view?id=${this.$route.meta.id}`
  },
  watch: {

  },
  methods: {

  },
  components: {

  },
  beforeRouteEnter (to, from, next) {
    document.title = '经营看板-coolita'
    next()
  }
}
</script>

<style scoped lang="stylus">
.iframe-wrap
  height 1080px
  width 100%
</style>
<style>
